import { Injectable, inject } from '@angular/core';
import { TwcRefreshLayerPluginService } from '../../../twc.refresh-layer-plugin.service';
import { RADAR_ECHO_TOPS_LEGEND } from './radar-echo-tops.legend';
import { RADAR_ECHO_TOPS_PRODUCT_DATA } from './radar-echo-tops.twc-product-data';

@Injectable({
  providedIn: 'root'
})
export class RadarEchoTopsPluginService {
  private readonly _twcPluginService = inject(TwcRefreshLayerPluginService);

  plugin$ = this._twcPluginService.create(RADAR_ECHO_TOPS_PRODUCT_DATA, {
    legend: RADAR_ECHO_TOPS_LEGEND,
    twcLayerTypes: ['web-tile']
  });
}
